<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Preparos</b>
                        </h3>
                        <router-link tag="a" class="btn btn-primary pull-right" to="/cadastros/preparos/novo" v-if="hasPermission('usuario.write')"><span class="fa fa-plus"></span> Novo</router-link>
                    </div>
                    <div class="box-body">
                        <form @submit.prevent="getDataTable()" action="">
                            <div class="row">
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <label for="">ID</label>
                                        <input v-model="filtros.id" class="form-control" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-9">
                                    <div class="form-group">
                                        <label for="">Nome do preparo</label>
                                        <input v-model="filtros.pesquisa" class="form-control" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="">&nbsp;</label>
                                        <button class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th width="5%">Id</th>
                                        <th>Nome</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <router-link tag="tr" :to="'/cadastros/preparos/editar/' + item.id" class="hand" v-for="(item, index) in dataTable.data" :key="index">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.nome }}</td>
                                    </router-link>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                            <div class="col-sm-7" style="text-align:right">
                                <laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
                                    <span slot="prev-nav">&lt; Anterior</span>
                                    <span slot="next-nav">Próximo &gt;</span>
                                </laravue-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
    data: () => ({
        filtros: {
            pesquisa: "",
            id: ""
        },
        dataTable: {}
    }),
    mounted() {
        this.getDataTable();
    },
    methods: {
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/preparos/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        }
    },
    components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?6a3a2e72